<br />
<p-panel [toggleable]="true" [collapsed]="true" toggler="header">
  <ng-template #header>
    <div class="font-bold">
      {{ 'project.steps.systemRecording.legend' | transloco }}
    </div>
  </ng-template>

  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <div class="grid grid-cols-2 gap-3 p-2">
    <div class="flex flex-col gap-3">
      <span class="text-sm opacity-80">
        {{ 'project.steps.systemRecording.scope' | transloco }}
      </span>

      <div class="flex items-center gap-3">
        <app-module-function-status-badge [type]="'IN_SCOPE'" />
        <span class="text-sm opacity-80">
          {{ 'project.steps.systemRecording.inScope' | transloco }}
        </span>
      </div>

      <div class="flex items-center gap-3">
        <app-module-function-status-badge [type]="'OUT_OF_SCOPE'" />
        <span class="text-sm opacity-80">
          {{ 'project.steps.systemRecording.outOfScope' | transloco }}
        </span>
      </div>
    </div>

    <div class="flex flex-col gap-3">
      <span class="text-sm opacity-80">
        {{ 'project.steps.systemRecording.status' | transloco }}
      </span>

      <div class="flex items-center gap-3">
        <app-module-function-status-badge [type]="'NEW'" />
        <span class="text-sm opacity-80">
          {{ 'project.steps.systemRecording.new' | transloco }}
        </span>
      </div>

      <div class="flex items-center gap-3">
        <app-module-function-status-badge [type]="'RETAIN'" />
        <span class="text-sm opacity-80">
          {{ 'project.steps.systemRecording.retain' | transloco }}
        </span>
      </div>

      <div class="flex items-center gap-3">
        <app-module-function-status-badge [type]="'REPLACE'" />
        <span class="text-sm opacity-80">
          {{ 'project.steps.systemRecording.replace' | transloco }}
        </span>
      </div>

      <div class="flex items-center gap-3">
        <app-module-function-status-badge [type]="'NOT_RELEVANT'" />
        <span class="text-sm opacity-80">
          {{ 'project.steps.systemRecording.notRelevant' | transloco }}
        </span>
      </div>

      <div class="flex items-center gap-3">
        <app-module-function-status-badge [type]="'NO_SYSTEM'" />
        <span class="text-sm opacity-80">
          {{ 'project.steps.systemRecording.newSystem' | transloco }}
        </span>
      </div>
    </div>
  </div>
</p-panel>
